// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  perspective: 1000px;
  width: 200px;
  height: 200px;
  position: relative;
  margin: 0 auto;
  transform-style: preserve-3d;
  animation: spin 10s infinite linear;
}

.carousel__face {
  position: absolute;
  width: 200px;
  height: 200px;
  line-height: 200px;
  color: white;
  text-align: center;
  font-size: 40px;
  transform: rotateY(var(--rotate)) translateZ(300px);
}

.carousel__face img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

@keyframes spin {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(1turn);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/carousel/carousel.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".carousel {\n  perspective: 1000px;\n  width: 200px;\n  height: 200px;\n  position: relative;\n  margin: 0 auto;\n  transform-style: preserve-3d;\n  animation: spin 10s infinite linear;\n}\n\n.carousel__face {\n  position: absolute;\n  width: 200px;\n  height: 200px;\n  line-height: 200px;\n  color: white;\n  text-align: center;\n  font-size: 40px;\n  transform: rotateY(var(--rotate)) translateZ(300px);\n}\n\n.carousel__face img {\n  width: 120px;\n  height: 120px;\n  object-fit: contain;\n}\n\n@keyframes spin {\n  from {\n    transform: rotateY(0deg);\n  }\n  to {\n    transform: rotateY(1turn);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
